<template>
  <div class="printCheck">
    <div style="margin: 10px;display: flex;justify-content: flex-end">
      <Button type="info" :loading="printLoading" v-print="print">打印</Button>
    </div>
    <div id="printArea">
      <table class="tables"
             border="1"
             align="center"
             cellspacing='0'
             style="border-collapse:collapse">
        <tr style="height: 40px">
          <td colspan="1">标题</td>
          <td colspan="3">{{ valData ? (valData.titlelang.zh || valData.titlelang.en || valData.titlelang.mn) : '' }}
          </td>
        </tr>
        <tr style="height: 40px">
          <td>作者</td>
          <td>{{ valData ? (valData.authorlang.zh || valData.authorlang.en || valData.authorlang.mn) : '' }}</td>
          <td>联系电话</td>
          <td>{{ valData ? valData.tel : '' }}</td>
        </tr>
<!--        :style="{minHeight:datalist.length>=4?'calc(calc(100vh - 100px) / 4)':'calc(calc(100vh - 100px) / 3)'}" :style="{minHeight:datalist.length>=4?'calc(calc(100vh - 100px) / 4)':'calc(calc(100vh - 100px) / 3)'}" -->
        <tr v-for="(item,index) in datalist" :key="index">
          <td colspan="1">{{ item.stage ? getstatusName(item.stage) : '' }}</td>
          <td colspan="3" style="padding: 0px">
            <div class="td_div" v-for="(e,j) in item.list" :key="j" :style="{borderTop:j==0?'0px solid #e9eaec !important':'' }"
                 style="padding: 10px">
              <div style="height:30px;display: flex;justify-content: space-between">
                <p style="width: 40%;text-align: center">{{ e.status ? getstatusName(e.status) : '' }}</p>
                <p style="width: 60%;text-align: center">{{e.zhuanjia_name?e.zhuanjia_name:''}}&nbsp;{{ e.created_at.slice(0,10) }}</p>
              </div>
              <div style="text-align: left;text-indent: 20px;" :class="!e.marklang.zh&&e.marklang.mn?'contentfont':''">
                {{ e.marklang ? (e.marklang.zh || e.marklang.mn) : '' }}
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>

export default {
  props: {
    infoData: {
      type: [Boolean, Object, Number],
      default: false,
    },
    userType: {//4作者 3专家 2编辑 1管理员
      type: [Boolean, Number, String],
      default: false,
    }
  },
  data() {
    let that = this
    return {
      loading: false,
      printLoading: false,
      print: {
        id: 'printArea',
        popTitle: '', // 打印配置页上方的标题
        extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
        preview: false, // 是否启动预览模式，默认是false
        previewTitle: '', // 打印预览的标题
        previewPrintBtnLabel: '', // 打印预览的标题下方的按钮文本，点击可进入打印
        zIndex: 30002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback() {
          that.printLoading = true
          // 正在加载预览窗口！
        }, // 预览窗口打开之前的callback
        previewOpenCallback() {
          that.printLoading = true
          // 已经加载完预览窗口，预览打开了！
        }, // 预览窗口打开时的callback
        beforeOpenCallback() {
          that.printLoading = true
          // 开始打印之前！

        }, // 开始打印之前的callback
        openCallback() {
          // 执行打印了
          that.printLoading = false
        }, // 调用打印时的callback
        closeCallback() {
          // 关闭了打印工具！
          that.printLoading = false
        }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted() {
          that.printLoading = true
          // 点击v-print绑定的按钮了！

        },
        standard: '',
        extarCss: ''
      },
      datalist: [1, 2, 3],
      valData: '',
      statusList: [
        {
          name: '未审核',
          lebal: 0
        },
        {
          name: '初审',
          lebal: 1
        },
        {
          name: '作者修改中',
          lebal: 2
        },
        {
          name: '作者修回稿件',
          lebal: 3
        },
        {
          name: '已录用稿件',
          lebal: 4
        },
        {
          name: '已退稿件 ',
          lebal: 5
        },
        {
          name: '复审',
          lebal: 6
        },
        {
          name: '外审',
          lebal: 7
        },
        {
          name: '终审',
          lebal: 8
        },
        {
          name: '审核中',
          lebal: 9
        },
        {
          name: '审核通过',
          lebal: 10
        },
        {
          name: '驳回',
          lebal: 11
        }
      ],
    }
  },
  methods: {
    getstatusName(value) {
      let gg = this.statusList.find(i => {
        return i.lebal == value
      });
      return gg ? gg.name : '';
    },
    /*****************************************************************
     * 单条
     *****************************************************************/
    queryData() {
      this.loading = true
      let cond = {
        id: this.infoData,
      }
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/check', cond).then(val => {
        console.log('审核记录',val)
        if (val.code == 200 && val.data) {
          this.valData = val.data
          if (this.valData.datalist && this.valData.datalist.length) {
            this.datalist = val.data.datalist
          }
        } else {
          this.valData = ''
          this.datalist = []
        }

        this.loading = false
      }).catch(err => {
        this.valData = ''
        this.loading = false
      })
    },

  },
  created() {
    this.queryData()
  },
  mounted() {
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.printCheck {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .inClaii {
    width: 100%;
    min-height: 34px;
    font-size: 14px;
    display: flex;
  }


  .tables {
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;


    td {
      padding: 10px;
      font-size: 14px;
      color: #5f5f5f;
      border: 1px solid #e9eaec;
      text-align: center;
      width: 25%;

      .td_div {
        border-top: 1px solid #e9eaec !important;
      }
    }

    tr {
      width: 100%;
    }

  }


}
</style>
<style lang="less">

@media print {
  body {
    background: white !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  *{
    background: white !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .tables {
    width: calc(100% - 2px);
    height: 100vh;
    margin: 0 auto;
    td {
      padding: 10px;
      font-size: 14px;
      text-align: center;
      color: #5f5f5f;
      border: 1px solid #000000;
      width: 25%;
      .td_div {
        border-top: 1px solid #000000 !important;
      }
    }
    tr {
      width: 100%;
    }
  }
}
</style>
